import { atom } from "jotai";
var PageFXPlayer = /** @class */ (function () {
    function PageFXPlayer() {
        this.lastPlay = Date.now();
        this.volume = 1;
        this.i = 0;
    }
    PageFXPlayer.prototype.play = function () {
        var dt = Date.now() - this.lastPlay;
        if (dt > 1000) {
            this.i = 0;
        }
        else {
            this.i = (this.i + 1) % 3;
        }
        // if (dt < 300) return;
        var track = document.createElement("audio");
        track.crossOrigin = "use-credentials";
        track.src =
            this.i === 0
                ? require("../private_assets/page_sfx/pageturn_3.mp3")
                : require("../private_assets/page_sfx/pageturn_2.mp3");
        track.volume = this.volume;
        track.playbackRate = 1;
        track.play();
        this.lastPlay = Date.now();
    };
    PageFXPlayer.prototype.setVolume = function (volume) {
        this.volume = volume;
    };
    return PageFXPlayer;
}());
export { PageFXPlayer };
export var PageFXPlayerAtom = atom(function () { return new PageFXPlayer(); });
